import emojiIcon from "@loot-os/icons/icons/emoji";
import moreIcon from "@loot-os/icons/icons/more";
import replyIcon from "@loot-os/icons/icons/reply";
import type { ReactElement } from "react";

import { IconButton } from "../../core/IconButton.js";
import { cn } from "../../foundations/cn.js";

export interface ChatMessageActionsProps {
  /** Opens the reaction picker; leave out where reacting isn't allowed. */
  react?: { label: string; onClick?: () => void; render?: ReactElement };
  reply?: { label: string; onClick: () => void };
  /**
   * The rest (mute, report, delete) behind one button: pass a Menu whose trigger is
   * `<ChatMessageActions.MoreButton label="More" />`.
   */
  more?: ReactElement;
  className?: string;
}

function MoreButton({ label, ...props }: { label: string } & Record<string, unknown>) {
  return <IconButton icon={moreIcon} label={label} variant="ghost" size="sm" {...props} />;
}

/**
 * A message's hover controls: react, reply, and a menu for the rest. ChatMessage shows them on
 * hover and on keyboard focus within the row, floating over its top-right corner.
 */
export function ChatMessageActions({ react, reply, more, className }: ChatMessageActionsProps) {
  return (
    <div
      className={cn(
        "flex items-center gap-0.5 rounded-md border border-border-default bg-bg-raised p-0.5 shadow-float",
        className,
      )}
    >
      {react && (
        <IconButton
          icon={emojiIcon}
          label={react.label}
          variant="ghost"
          size="sm"
          onClick={react.onClick}
          render={react.render}
        />
      )}
      {reply && (
        <IconButton
          icon={replyIcon}
          label={reply.label}
          variant="ghost"
          size="sm"
          onClick={reply.onClick}
        />
      )}
      {more}
    </div>
  );
}

ChatMessageActions.MoreButton = MoreButton;
